import { inject, Injectable } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { LegendComponent } from 'src/app/components/manufacturer/popovers/legend/legend.component';
import { ManufacturerProfileComponent } from 'src/app/components/manufacturer/popovers/manufacturer-profile/manufacturer-profile.component';
import { SeeBatchComponent } from 'src/app/components/manufacturer/popovers/see-batch/see-batch.component';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class ManufacturerPopoversService {
  popoverCtrl = inject(PopoverController);

  async openProfilePage(ev: any, email) {
    const popover = await this.popoverCtrl.create({
      component: ManufacturerProfileComponent,
      backdropDismiss: true,
      componentProps: { email },
      event: ev,
      cssClass: 'center-text  color-white',

    });

    await popover.present();

    return await popover.onDidDismiss();
  }

  async openLegend() {
    const popover = await this.popoverCtrl.create({
      component: LegendComponent,
      backdropDismiss: true,
      // componentProps: { email },
      // event: ev,
      cssClass: 'center-text  color-white wide-popover',

    });

    await popover.present();

    return await popover.onDidDismiss();
  }

  async openBatch() {
    const popover = await this.popoverCtrl.create({
      component: SeeBatchComponent,
      backdropDismiss: true,
      // componentProps: { email },
      // event: ev,
      cssClass: 'center-text color-white batch-detail-popover',

    });

    await popover.present();

    return await popover.onDidDismiss();
  }

  //Swals
  loginSwal() {
    Swal.fire({
      title: `Benvenuto! 🙂`,
      text: 'Stai per essere reindirizzato alla tua dashboard...',
      timer: 3000,
      timerProgressBar: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  logoutSwal() {
    Swal.fire({
      title: `Arrivederci! 👋`,
      text: 'Speriamo di rivederti presto',
      timer: 3000,
      timerProgressBar: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  addedOrderSwal() {
    Swal.fire({
      title: `Ordine aggiunto`,
      text: "L'ordine è stato correttamente aggiunto alla lista 'In lavorazione'",
      timer: 3000,
      timerProgressBar: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  noOrderFoundSwal() {
    Swal.fire({
      title: `Ordine non trovato`,
      text: "L'ordine richiesto non è presente nel sistema.",
      timer: 3000,
      timerProgressBar: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  serverErrorSwal() {
    Swal.fire({
      title: `Errore del server`,
      text: "Si è verificato un problema sul server. Riprova più tardi.",
      timer: 3000,
      timerProgressBar: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  errorSwal(message: string) {
    Swal.fire({
      icon: 'error',
      title: `Errore`,
      text: message,
      timer: 3000,
      timerProgressBar: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  successSwal(message: string) {
    Swal.fire({
      icon: 'success',
      title: 'Successo',
      text: message,
      timer: 3000,
      timerProgressBar: true,
      showCancelButton: false,
      showConfirmButton: false,
    });
  }

  async askForListElementDelete(): Promise<boolean> {
    return new Promise((resolve) => {
      Swal.fire({
        title: 'Elimina ordine',
        text: 'Sei sicuro di voler eliminare questo ordine?',
        showCancelButton: true,
        confirmButtonColor: '#00CB51',
        cancelButtonColor: '#CD002B',
        confirmButtonText: 'Sì',
        cancelButtonText: 'No',
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

  async askForDocumentDelete(): Promise<boolean> {
    return new Promise((resolve) => {
      Swal.fire({
        title: 'Elimina pdf',
        text: 'Sei sicuro di voler eliminare il pdf? L’azione è irreversibile',
        showCancelButton: true,
        confirmButtonColor: '#00CB51',
        cancelButtonColor: '#CD002B',
        confirmButtonText: 'Sì',
        cancelButtonText: 'No',
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

  async askForDDTDelete(): Promise<boolean> {
    return new Promise((resolve) => {
      Swal.fire({
        title: 'Elimina DDT',
        text: 'Sei sicuro di voler eliminare il DDT? L’azione è irreversibile',
        showCancelButton: true,
        confirmButtonColor: '#00CB51',
        cancelButtonColor: '#CD002B',
        confirmButtonText: 'Sì',
        cancelButtonText: 'No',
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

  async approveOrder(): Promise<boolean> {
    return new Promise((resolve) => {
      Swal.fire({
        title: '<span style="color:#017efa">APPROVA</span>',
        text: 'Il fornitore caricando i file si assume la veridicità delle informazioni inserite',
        showCancelButton: true,
        confirmButtonColor: '#00CB51',
        cancelButtonColor: '#CD002B',
        confirmButtonText: '<span style="display:flex;align-items:center;gap:6px"><svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/></svg>SI</span>',
        cancelButtonText: '<span style="display:flex;align-items:center;gap:6px"><svg width="16" height="16" viewBox="0 0 24 24" fill="white"><path d="M18.3 5.71L12 12.01 5.7 5.7 4.29 7.12 10.59 13.42 4.3 19.71 5.71 21.12 12.01 14.83 18.3 21.12 19.71 19.71 13.42 13.42 19.71 7.12z"/></svg>NO</span>',
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

  async completeOrder(number: string): Promise<boolean> {
    return new Promise((resolve) => {
      Swal.fire({
        title: `Ordine n° ${number}`,
        text: 'Ordine processato. I dettagli dell’ordine sono stati scelti e non sono modificabili.',
        showCancelButton: true,
        confirmButtonColor: '#00CB51',
        cancelButtonColor: '#CD002B',
        confirmButtonText: 'Conferma',
        cancelButtonText: 'No',
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

  async goToDocumentsList(): Promise<boolean> {
    return new Promise((resolve) => {
      Swal.fire({
        title: 'Documenti caricati',
        html: `
    <div>Hai caricato tutti i documenti?</div>
    <small style="opacity: 0.7;">
      Puoi continuare a caricarne altri oppure procedere allo step successivo
    </small>
  `, showCancelButton: true,
        confirmButtonColor: '#00CB51',
        cancelButtonColor: '#CD002B',
        confirmButtonText: 'Sì',
        cancelButtonText: 'No',
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

  async showQtyVariation(text: string): Promise<boolean> {
    return new Promise((resolve) => {
      Swal.fire({
        title: 'Quantità effettiva',
        text: text,
        showCancelButton: false,
        confirmButtonColor: '#00CB51',
        confirmButtonText: 'Sì',
      }).then((result) => {
        resolve(result.isConfirmed);
      });
    });
  }

}
